<script setup>
defineEmits(['close'])

const props = defineProps({
  closeButton: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <v-card-title class="d-flex flex-row justify-space-between align-center">
    <div>
      <slot></slot>
    </div>
    <v-btn
        v-if="props.closeButton"
        class="ma-0 pa-0"
        variant="flat"
        :ripple="false"
        icon="mdi-close"
        @click="$emit('close')"
    />
  </v-card-title>
</template>
